import {
    findOrderId,
    urlOrderId,
    fetchAsync,
} from '../helpers.js'

let orderDetails = {}

async function addTrackOrderBtn(){
    const language = window[window.config.padl.namespace].dataLayer.page.page.pageInfo.language.toLowerCase()
    const country = window[window.config.padl.namespace].dataLayer.app.app.market.toLowerCase()

    let trackTraceUrl = window.trackTrace && window.trackTrace.myOrder_translations ? window.trackTrace.myOrder_translations[language.toLowerCase()].btn_url : '',
        trackTraceLabel = window.trackTrace && window.trackTrace.myOrder_translations ? window.trackTrace.myOrder_translations[language.toLowerCase()].btn_text : ''

    if(!trackTraceUrl && !trackTraceLabel){
        return false
    }
    const orderNum = orderDetails.orderId
    const customerEmail = await getCustomerEmail()

    let trackOrderLinkBtn = document.createElement("a")
    trackOrderLinkBtn.id = "trackOrderBtn"
    trackOrderLinkBtn.target="_blank"
    trackOrderLinkBtn.className = "resposive-link my-order-track-order-btn"

    const trackUrl = "/"+country+"/"+language+trackTraceUrl+"?pp_order_id="+orderNum+"&pp_email="+ customerEmail
    trackOrderLinkBtn.href= trackUrl

    trackOrderLinkBtn.setAttribute('aria-label', trackTraceLabel)
    trackOrderLinkBtn.innerHTML = trackTraceLabel

    document.querySelector('.my-order-details__buttons').append(trackOrderLinkBtn)

    if(window.matchMedia("(min-width: 996px)").matches){
        const reOrderBtnHeight = document.querySelector('.my-orders-details__reorder-button').offsetHeight
        const trackOrderBtnheight = document.querySelector('.my-order-track-order-btn').offsetHeight

        let totalHeight = reOrderBtnHeight + trackOrderBtnheight + 24
        document.querySelector('.my-order-details__title').style.height =`${totalHeight}px`
    }
    else{
        document.querySelector('.my-order-details__title').style.marginTop= `40px`
    }
}

const getCustomerEmail = async ()=>  {
    const customerInfo =  await window.napi.customer().read()
    return customerInfo.email || ''
}

const getOrderDetails = () => {
    const padl = window[window.config.padl.namespace].dataLayer
    const page = padl.page.page.pageInfo
    const language = page.language.toLowerCase()
    const country = padl.app.app.market.toLowerCase()
    const businessSegment = page.segmentBusiness.toLowerCase()
    // Find order ID in url
    let orderId = urlOrderId()

    // Find order ID in page
    if (!orderId) {
        orderId = findOrderId()
    }

    const APIUrl = `/ecapi/checkout/v6/${country}/ecommerce/${businessSegment}/me/orders/${orderId}?language=${language}`
    // Founded EncryptionURL
    if (orderId) {
        fetchAsync(APIUrl)
            .then(orderDetailsResult => {
                orderDetails = orderDetailsResult
                if(showOrderBySource() && !hideOrderByStatus()){
                    addTrackOrderBtn().then()
                }
                else{
                    console.log('don\'t display the track button')
                }
            })
            .catch(error => {
                console.error('Fetch Order Details API error: ',error)
            })
    }
}

const showOrderBySource = () => {
    const language = window[window.config.padl.namespace].dataLayer.page.page.pageInfo.language.toLowerCase()
    const orderSourceIds = window.trackTrace && window.trackTrace.myOrder_translations
        ? window.trackTrace.myOrder_translations[language.toLowerCase()].orderSourceIds : ['I']
    return orderSourceIds.includes(orderDetails["orderSourceId"])
}

const hideOrderByStatus = () => {
    const language = window[window.config.padl.namespace].dataLayer.page.page.pageInfo.language.toLowerCase()
    const orderStatus = window.trackTrace && window.trackTrace.myOrder_translations
        ? window.trackTrace.myOrder_translations[language.toLowerCase()].orderStatusHide : ['DELIVERED']
    return orderStatus.includes(orderDetails.status)
}

const myInterval = setInterval(() => {
    if(window.config && window.config.padl) {
        getOrderDetails()
        clearInterval(myInterval);
    }
}, 100);
